export const styles = {
  footerActions: 'tw-flex tw-justify-end tw-gap-2',
  message: 'tw-m-0 tw-text-sm tw-text-neutral-600',
};
